import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationPage from "src/components/StatusBackground/ConfirmationPage";
import QuantcastPixel from "src/components/QuantcastPixel";
import { useAccount } from "src/context/account/account.provider";

const qcastPixel = process.env.REACT_APP_QCAST_PIXEL;

const NewUser = () => {
  const { t } = useTranslation();
  const { orderId } = useAccount();
  return (
    <>
      {qcastPixel === "true" && (
        <QuantcastPixel label="Rewards Account Sign Up" orderId={orderId} />
      )}
      <ConfirmationPage title={t("newUser.title")} icon="svg/Check.svg">
        <h4>{t("newUser.welcomeTitle")}</h4>
        <h4>{t("newUser.instructionsTitle")}</h4>
        <p>{t("newUser.thankYou")}</p>
        <p>{t("newUser.requestSent")}</p>
        <p>{t("newUser.cardCreation")}</p>
        <p>{t("newUser.pickupInfo")}</p>
      </ConfirmationPage>
    </>
  );
};

export default NewUser;
